// import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrdersActionTypes } from "./types/actionTypes";
import { OrdersState } from "./types";
import { OrdersActions } from "./actionCreators";

const initialState: OrdersState = {
  orders: [],
  only_active: false,
  field: null,
  direction: null,
  order_error_message: "",
  page: 1,
  per_page: 10,
  page_count: 0,
  total_count: 0,
};

const ordersReducer = (
  state = initialState,
  action: OrdersActions
): OrdersState => {
  switch (action.type) {
    case OrdersActionTypes.FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload.orders,
        page: action.payload.pagination.page,
        page_count: action.payload.pagination.page_count,
        per_page: action.payload.pagination.per_page,
        total_count: action.payload.pagination.total_count,
        field: action.payload.field,
        direction: action.payload.direction,
      };
    case OrdersActionTypes.FETCH_ORDERS_ERROR:
      return {
        ...state,
        orders: [],
        page: 1,
        per_page: 10,
        page_count: 0,
        total_count: 0,
      };
    case OrdersActionTypes.FETCH_ORDER_ERROR_MESSAGE_SUCCESS:
      return {
        ...state,
        order_error_message: action.payload,
      };
    case OrdersActionTypes.CLEAR_ORDER_ERROR_MESSAGE:
      return {
        ...state,
        order_error_message: "",
      };

    default:
      return state;
  }
};
export default ordersReducer;
